import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ButtonLoadingService } from '@teams-ui-angular';

@Component({
  selector: 'cloudlabs-delete-button',
  templateUrl: './delete-button.component.html',
  styleUrls: ['./delete-button.component.scss']
})
export class DeleteButtonComponent implements OnInit {
  @Output() actionClickEvent = new EventEmitter<string>();
  @Output() markAsCompleteEvent = new EventEmitter(null);

  @Input() showMarkComplete = false;
  @Input() showButtonLoading = false;
  constructor(public btnLoadingService: ButtonLoadingService) {
    //
   }

  ngOnInit(): void {
    //
  }

  actionClick(action) {
    this.actionClickEvent.emit(action);
  }

  markAsComplete() {
    this.markAsCompleteEvent.emit();
  }

}
